import { TFunction } from 'i18next';

export type InvoiceKindKey =
  | 'not_target'
  | 'qualified'
  | 'unqualified_eighty'
  | 'unqualified_seventy'
  // | 'unqualified_fifty'
  | 'unqualified';

const INVOICE_KIND_KEYS: ReadonlySet<string> = new Set<InvoiceKindKey>([
  'not_target',
  'qualified',
  'unqualified_eighty',
  'unqualified_seventy',
  // 'unqualified_fifty',
  'unqualified',
]);

function isInvoiceKindKey(value: string): value is InvoiceKindKey {
  return INVOICE_KIND_KEYS.has(value);
}

/** Returns a label only when `invoice_kind` matches a known key; otherwise `''`. */
export function getInvoiceKindLabel(
  t: TFunction,
  invoiceKind: string | null | undefined
): string {
  if (invoiceKind === undefined || invoiceKind === null || invoiceKind === '') {
    return '';
  }
  if (isInvoiceKindKey(invoiceKind)) {
    return t(`invoice_kind.${invoiceKind}`);
  }
  return '';
}
